export default __webpack_public_path__ + "static/img/suggested-bg.6101d2b.jpg";